import React, { useState, useEffect } from "react";
import { Card, OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import "./waitingUserDashboard.scss";
import AddUserByAdmin from "../addUserByAdmin/addUserByAdmin";
import AcceptRejectModal from "../../jsx/components/modalAcceptReject/modalAcceptreject";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getWaitingUsersApi } from "../../service/api/user/getWaitingUsers";
import deleteWaitingUser from "../../service/api/user/deleteWaitingUser";
import { signUp } from "../../service/api/user/signUp";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";
import PaginationAndSearching from "../../component/paginationAndSearching/paginationAndSearching";
import SkeletonTableRow from "../../component/skeletonTableRow/skeletonTableRow";
import InternationalPhoneFormat from "../../ui/InternationalPhoneFormat";
import { lblEmail, lblPhoneNumber, txtAction, txtCreatedDate, txtFullName, txtNoRecordsFound, txtRole, txtWaitingList } from "../../dataBaseFile/label";
import { btnAddUser } from "../../dataBaseFile/alert";

const WaitingUserDashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [modalRejectStatus, setModalRejectStatus] = useState(false);
  const [modalAcceptStatus, setModalAcceptStatus] = useState(false);
  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPage, setTotalPage] = useState(1);
  const [sortByValue, setSortByValue] = useState("DESC");
  const [searchValue, setSearchValue] = useState("");
  const [resMessage, setResMessage] = useState("");
  const [bulkDeleteArr, setBulkDeleteArr] = useState([]);
  const [skeltonVal, setSkeltonVal] = useState(false);
  const [resDialog, setResDialog] = useState(false);
  const [columnName, setColumnName] = useState("created_date_dtm");
  const [totalNoRecord, setTotalNoRecord] = useState(100);
  const [elements, setElements] = useState([]);
  const [flag, setFlag] = useState(false);
  const [waitingUserData, setWaitingUserData] = useState();
  const [handleToaster, setHandleToaster] = useState(false);
  const [toasterType, setToasterType] = useState();
  const [sortingCol, setSortingCol] = useState(true);
  const [firstCheck, setFirstCheck] = useState(false);
  const [customeSkeletonLoaing, setCustomeSkeletonLoaing] = useState(false);

  const rows = elements;

  function onLoad() {
    const waitingData = new FormData();
    setCustomeSkeletonLoaing(true);
    waitingData.append(
      "user_id_ids",
     localStorage.getItem("user_id")
    );
    waitingData.append("page_index", page);
    waitingData.append("page_size", pageSize);
    waitingData.append("sorting_order", sortByValue);
    waitingData.append("sorting_column_name", columnName);
    waitingData.append("search_area", searchValue);

    dispatch(
      getWaitingUsersApi(waitingData, (res) => {
        setElements(res.data.data);
        setCustomeSkeletonLoaing(false);
        setTotalNoRecord(res.data.total_count);
        if (res.data.total_count % pageSize === 0) {
          setTotalPage(parseInt(res.data.total_count / pageSize));
        } else {
          setTotalPage(parseInt(res.data.total_count / pageSize + 1));
        }
      }, (err) => {
        setCustomeSkeletonLoaing(false);
      })
    );
  }

  const handleColumnName = (name) => {
    setSortingCol(false);
    setColumnName(name);

    if (sortByValue === "ASC") {
      setSortByValue("DESC");
    }
    if (sortByValue === "DESC") {
      setSortByValue("ASC");
    }
  };

  const handleOrderValue = (order) => {
    setSortByValue(order);
  };

  const handleSearch = (e) => {
    // setPage(1)

    setSearchValue(e.target.value);
    if (searchValue.trim().length >= 2) {
      onChangePage(1)
      setColumnName('')
    }
  };

  const handleChangeRowsPerPage = (e) => {
    // console.log(e)
    setSearchValue("");
    setPage(1);
    setPageSize(e.target.value);
  };

  const onChangePage = (e, p) => {
    // setPage(p);
    setPage(e);
  };

  function addNewUser() {
    navigate("/addUserByAdmin");
  }

  function approveUser() {
    console.log(waitingUserData);
    let details = {
      first_name_chr: waitingUserData.first_name_chr,
      last_name_chr: waitingUserData.last_name_chr,
      role_id_int: parseInt(waitingUserData.role_id_int),
      phone_code_id_int: parseInt(waitingUserData.phone_code_id_lng),
      phone_number_int: parseInt(waitingUserData.phone_number_int),
      email_chr: waitingUserData.email_chr,
      password: "YourString@123",
      confirm_password: "YourString@123",
      creator_user_id_ids: localStorage.getItem("user_id"),
    };

    dispatch(
      signUp(
        details,
        (res) => {
          setModalAcceptStatus(false)
          setResMessage(res.data.message);
          setResDialog(true);
          setToasterType("success")
          onLoad();
          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        },
        (err) => {
          setModalAcceptStatus(false)
          setResMessage(err.data.message);
          setResDialog(true);
          setToasterType("error")
          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        }
      )
    );
  }

  function disApproveUser(ele) {
    let details = {
      user_id_ids: localStorage.getItem("user_id"),
      waiting_user_id_ids: waitingUserData.waiting_user_id_ids,
    };


    dispatch(
      deleteWaitingUser(
        details,
        (res) => {
          setModalRejectStatus(false)
          setResMessage(res.data.message);
          setResDialog(true);
          setToasterType("success")
          onLoad();
          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        },
        (err) => {
          setModalRejectStatus(false)
          setResMessage(err.data.message);
          setResDialog(true);
          setToasterType("error")
          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        }
      )
    );
  }

  function handleClose() {
    setResDialog(false);
  }

  useEffect(() => {
    onLoad();
  }, [sortByValue, pageSize, page, columnName]);

  function onLoadSearch() {
    setSkeltonVal(true);
    var data = {
      user_id_ids: localStorage.getItem("user_id"),
      page_index: 1,
      page_size: pageSize,
      sorting_order: sortByValue,
      sorting_column_name: "",
      search_area: searchValue,
    };
    dispatch(
      getWaitingUsersApi(data, (res) => {
        setElements(res.data.data);
        setTotalNoRecord(res.data.total_count);
        if (res.data.total_count % pageSize === 0) {
          setTotalPage(parseInt(res.data.total_count / pageSize));
        } else {
          setTotalPage(parseInt(res.data.total_count / pageSize + 1));
        }

        if (res.data.data.length === 0) {
          setTimeout(() => {
            setSkeltonVal(true);
          }, "3000");
        } else {
          setSkeltonVal(true);
        }
      })
    );
  }

  useEffect(() => {
    if (searchValue.trim().length > 2) {
      setFlag(true);
      const timeOutId = setTimeout(onLoadSearch, 1000);
      return () => clearTimeout(timeOutId);
    } else if (searchValue.trim().length === 0) {
      if (flag) {
        onLoadSearch();
      }
    }
  }, [searchValue]);

  const tooltipReject = (
    <Tooltip id="tooltip">
      <strong>Reject</strong>
    </Tooltip>
  );
  const tooltipAccept = (
    <Tooltip id="tooltip">
      <strong>Accept</strong>
    </Tooltip>
  );

  // Modal triggers for the Add user by admin
  const [showAddUser, setShowAddUser] = useState(false);

  const handleCloseAddUser = () => setShowAddUser(false);
  const handleShowAddUser = (e) => {
    e.stopPropagation();
    setShowAddUser(true);
  };

  return (
    <div>
      <Card>
        <div className="d-flex align-items-center service-requests-main">
          <div className="waiting-dashboard-title">{txtWaitingList}</div>

          <div
            className="d-flex justify-content-between slider-box-search"
            style={{ width: "60%" }}>
            <div className="admin-btn-group-container d-flex">
              <button
                onClick={(e) => handleShowAddUser(e)}
                className=" admin-btn-group"
                variant="light btn-rounded">
                <i
                  className="bi bi-plus-circle-fill"
                  style={{ marginRight: "10px" }}></i>
                {btnAddUser}
              </button>
            </div>

            <div>
              {/* <div className="admin-input-group input-group">
                <span className="input-group-text search-input-icon">
                  <i className="bi bi-search" style={{ fontSize: "16px" }}></i>
                </span>
                <input
                  type="text"
                  className="form-control search-input"
                  id="val-username1"
                  placeholder="Search Service.."
                  name="username"
                />
              </div> */}
            </div>
          </div>
        </div>
        <Card.Body>

          <PaginationAndSearching
            handleSearch={handleSearch}
            searchValue={searchValue}
            defaultValue={pageSize}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            totalCount={totalPage}
            onChange={onChangePage}
          />
          <Table responsive>
            <thead style={{ background: "#8080801c" }}>
              <tr>
                <th style={{ cursor: "pointer" }} onClick={() => { handleColumnName("first_name_chr"); setFirstCheck(true) }}>
                  <div className="d-flex align-items-center">
                    <strong>{txtFullName}</strong>
                    {sortingCol && <i style={{ fontSize: '11px' }} className="fa fa-fw fa-sort"></i>}

                    {sortByValue === "DESC" && columnName === "first_name_chr" && firstCheck && <i className="bi bi-arrow-down sorting-arrows" onClick={() => { handleOrderValue("ASC") }}></i>}

                    {sortByValue === "ASC" && columnName === "first_name_chr" && firstCheck && <i className="bi bi-arrow-up sorting-arrows" onClick={() => { handleOrderValue("DESC") }}></i>}


                  </div>
                </th>
                <th style={{ cursor: "pointer" }} onClick={() => { handleColumnName("role_id_int"); setFirstCheck(true) }}>
                  <div className="d-flex align-items-center">
                    <strong>{txtRole}</strong>
                    {sortingCol && <i style={{ fontSize: '11px' }} className="fa fa-fw fa-sort"></i>}
                    {sortByValue === "DESC" && columnName === "role_id_int" && firstCheck && <i className="bi bi-arrow-down sorting-arrows" onClick={() => { handleOrderValue("ASC") }}></i>}

                    {sortByValue === "ASC" && columnName === "role_id_int" && firstCheck && <i className="bi bi-arrow-up sorting-arrows" onClick={() => { handleOrderValue("DESC") }}></i>}

                  </div>
                </th>
                <th style={{ cursor: "pointer" }} onClick={() => { handleColumnName("email_chr"); setFirstCheck(true) }}>
                  <div className="d-flex align-items-center">
                    <strong>{lblEmail}</strong>
                    {sortingCol && <i style={{ fontSize: '11px' }} className="fa fa-fw fa-sort"></i>}
                    {sortByValue === "DESC" && columnName === "email_chr" && firstCheck && <i className="bi bi-arrow-down sorting-arrows" onClick={() => { handleOrderValue("ASC") }}></i>}

                    {sortByValue === "ASC" && columnName === "email_chr" && firstCheck && <i className="bi bi-arrow-up sorting-arrows" onClick={() => { handleOrderValue("DESC") }}></i>}

                  </div>
                </th>
                <th style={{ cursor: "pointer" }} onClick={() => { handleColumnName("phone_number_int"); setFirstCheck(true) }}>
                  <div className="d-flex align-items-center">
                    <strong>{lblPhoneNumber}</strong>
                    {sortingCol && <i style={{ fontSize: '11px' }} className="fa fa-fw fa-sort"></i>}
                    {sortByValue === "DESC" && columnName === "phone_number_int" && firstCheck && <i className="bi bi-arrow-down sorting-arrows" onClick={() => { handleOrderValue("ASC") }}></i>}

                    {sortByValue === "ASC" && columnName === "phone_number_int" && firstCheck && <i className="bi bi-arrow-up sorting-arrows" onClick={() => { handleOrderValue("DESC") }}></i>}

                  </div>
                </th>
                <th style={{ cursor: "pointer" }} onClick={() => { handleColumnName("created_date_dtm"); setFirstCheck(true) }}>
                  <div className="d-flex align-items-center">
                    <strong>{txtCreatedDate}</strong>
                    {sortingCol && <i style={{ fontSize: '11px' }} className="fa fa-fw fa-sort"></i>}
                    {sortByValue === "DESC" && columnName === "created_date_dtm" && firstCheck && <i className="bi bi-arrow-down sorting-arrows" onClick={() => { handleOrderValue("ASC") }}></i>}

                    {sortByValue === "ASC" && columnName === "created_date_dtm" && firstCheck && <i className="bi bi-arrow-up sorting-arrows" onClick={() => { handleOrderValue("DESC") }}></i>}

                  </div>
                </th>
                <th>
                  <div className="d-flex align-items-center">
                    <strong>{txtAction}</strong>
                    {/* <i className="fa fa-fw fa-sort"></i> */}
                  </div>
                </th>
              </tr>
            </thead>

            <tbody>

              {customeSkeletonLoaing ?
                <SkeletonTableRow cols={6} /> :
                <>
                  {rows.length > 0 ?
                    <>
                      {rows.map((element, index) => {
                        return (
                          <>
                            <tr
                              key={index}
                              onClick={() => { }}
                              className="notification-rows"
                              style={{ fontSize: "13px", cursor: "default" }}>
                              <td
                                style={{
                                  borderTopLeftRadius: "20px !important",
                                  borderBottomLeftRadius: "20px !important",
                                }}>
                                {element.full_name_chr}
                              </td>

                              <td>{element.role_name_chr}</td>

                              <td>{element.email_chr ? element.email_chr : "NA"}</td>

                              <td>
                                {/* {element.phone_number_int == null
                              ? "NA"
                              : element.phone_number_int} */}

                                {element.phone_number_int == null ? ('NA') : <InternationalPhoneFormat countryCode={`${element.country_phone_code_chr}`} phoneNumber={`${element.phone_number_int}`} />}

                              </td>

                              <td>
                                {" "}
                                {new Intl.DateTimeFormat("en-US", {
                                  year: "numeric",
                                  month: "long",
                                  day: "numeric",
                                }).format(element.created_date_dtm + "000")}
                              </td>
                              <td>
                                <div
                                  className="d-flex align-items-center"
                                  style={{ justifyContent: "space-around" }}>
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={tooltipAccept}>
                                    <div
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setModalAcceptStatus(true);
                                        setWaitingUserData(element);
                                      }}
                                      className="d-flex align-items-center justify-content-center"
                                      style={{
                                        color: "#0AC947",
                                        fontSize: "21px",
                                        cursor: "pointer",
                                      }}>
                                      <i className="bi bi-check-circle-fill" />
                                    </div>
                                  </OverlayTrigger>

                                  <OverlayTrigger
                                    placement="top"
                                    overlay={tooltipReject}>
                                    <div
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setModalRejectStatus(true);
                                        setWaitingUserData(element);
                                      }}
                                      className="d-flex align-items-center justify-content-center"
                                      style={{
                                        color: "#FF0000",
                                        fontSize: "21px",
                                        cursor: "pointer",
                                      }}>
                                      <i className="bi bi-x-circle-fill"></i>
                                    </div>
                                  </OverlayTrigger>
                                </div>
                              </td>
                            </tr>
                          </>
                        );
                      })}
                    </> :
                    <tr style={{ fontSize: '13px', backgroundColor: '#fff', }}>
                      <td colSpan="7">{txtNoRecordsFound}</td>
                    </tr>
                  }
                </>
              }

            </tbody>
          </Table>
        </Card.Body>
      </Card>
      {/* </Col>
            </Row> */}

      <AcceptRejectModal
        text={"Are you sure you want to Reject this account ?"}
        onClickReject={() => setModalRejectStatus(false)}
        onClickAccept={disApproveUser}
        modalStatus={modalRejectStatus}
      />

      <AcceptRejectModal
        text={"Are you sure you want to allow this account"}
        onClickAccept={approveUser}
        onClickReject={() => setModalAcceptStatus(false)}
        modalStatus={modalAcceptStatus}
      />

      <AddUserByAdmin
        addUserTrigger={showAddUser}
        handleCloseAddUser={handleCloseAddUser}
      />

      {handleToaster && <ResponceToaster toasterType={toasterType} message={resMessage} />}
    </div>
  );
};

export default WaitingUserDashboard;
